import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
<wa-divider class="divider-line"></wa-divider>
`
class NavHeaderPrimaryDivider extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryDivider connectedCallback', this)
    //this.reloadCss()
  }
}

if (!customElements.get('ts-navheader-primary-divider')) {
  customElements.define('ts-navheader-primary-divider', NavHeaderPrimaryDivider)
}
export { NavHeaderPrimaryDivider }
